import { MSafeWallet } from '@msafe/sui-wallet';

export const useInMsafeWallet = () => {
  return MSafeWallet.inMSafeWallet();
};
